import autobind from 'autobind-decorator';
import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {Button, DatePicker, Form, Icon, Input, Select, Spin} from 'antd';
import {connect} from 'redux-scaffolding-ts';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {ProjectsStore, ProjectSummary} from 'src/stores/projects-store';
import {EmployeesStore, EmployeeSummary} from 'src/stores/employees-store';
import {Query} from 'src/core/stores/dataStore';
import {TableModel, TableView} from 'src/core/ui/collections/table';
import {formatMessage} from 'src/core/services/http.service';
import {withIdentity} from '../../../core/services/authentication';
import {ExpandedLogItem, LogsStore} from '../../../stores/logs-store';
import {Moment} from 'moment'
import moment from 'moment-timezone';
import FormItem from 'antd/lib/form/FormItem';
import {nameof, unixEpochToDate} from '../../../core/utils/object';
import {FormComponentProps, GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import FileSaver from 'file-saver';
import {UserProfileProps, withUserProfile} from "../../../components/user-profile";
import { successNotification } from '../../../components/systemNotifications/notificationService';

const { Option } = Select;

interface LogsRequest {
    types: string [];
    fromDateStamp: number;
    toDateStamp: number;
    from: Moment,
    to: Moment,
    employees: EmployeeSummary[],
    projects: ProjectSummary[],
    tasks: [number, string][],
    indexProjects: { [id: string]: ProjectSummary },
    
}

interface LogsRequestFormBodyProps extends WithTranslation {
    item: LogsRequest | undefined,
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    getFieldValue: (name: string) => any;
    validateFields: (fieldNames?: string[], options?: any, callback?: any) => void;
    setFieldsValue: any;
    data: any;
    employees: EmployeeSummary[];
    projects: ProjectSummary[];
    tasks: any[];
    indexProjects: { [id: string]: ProjectSummary };
}
interface LogsRequestFormBodyState {
    possibleTasks: any[]
}

const eventType = Object.freeze({
    "TimesheetEntryUpdated":1,
    "TimesheetPublished":2,
    "TimesheetAcceptedOrRejected":3,
    "ProjectOrTaskCreatedOrModified":4})

const defaultTypes = [eventType.ProjectOrTaskCreatedOrModified,
    eventType.TimesheetAcceptedOrRejected,
    eventType.TimesheetEntryUpdated,
    eventType.TimesheetPublished]
const defaultFromDate = moment().startOf('day').subtract(1, 'day')
const defaultToDate = moment().endOf('day').add(1, 'day')

class LogsRequestFormBody extends React.Component<LogsRequestFormBodyProps, LogsRequestFormBodyState> {
    constructor(props: LogsRequestFormBodyProps) {
        super(props);
        this.state = {
            possibleTasks: props.tasks.map(t => t.item2),
        }
    }
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.employees.length !== this.props.employees.length || nextProps.projects.length !== this.props.projects.length) {
            var emptyArr = [] as object[]
            var tasks = nextProps.projects ? emptyArr.concat.apply([], nextProps.projects.map((value: any, index: any) => {
                var options = value.tasks
                return options
            })) : [] as object[]
            this.setState({
                possibleTasks: tasks,
                
            });
        }
    }

    @autobind
    private async validatProjectSelection(rule: any, value: any) {
        const { t } = this.props;
        if (value === undefined) {
            throw new Error(t('At least one log type must be specified'))
        }
    }

    @autobind
    private disabledEndDate(date: Moment | null) {
        if (!date)
            return false

        var startDate = this.props.getFieldValue(nameof<LogsRequest>('from'))
        if (startDate == undefined)
            return false;

        return date.utc().endOf("day") < startDate
    }

    @autobind
    private onProjectsChange(e: any) {
        var emptyArr = [] as object[]
        var possibleTasks = emptyArr.concat.apply([], e.map((value: any, index: any) => {
            var options = this.props.projects ? this.props.indexProjects[value].tasks : [] as object[]
            return options
        }))
        this.setState({
            possibleTasks: possibleTasks ? possibleTasks: []
        })
    }

    @autobind
    private disabledStartDate(date: Moment | null) {
        if (!date)
            return false

        var endDate = this.props.getFieldValue(nameof<LogsRequest>('to'))
        if (endDate == undefined)
            return false;

        return date.utc().startOf("day") > endDate
    }

    render() {
        const { t } = this.props;
        var item = this.props.item || {} as LogsRequest;
        var defaultTasks = this.state.possibleTasks ?
            this.state.possibleTasks.map((t: any, i: number) => {
                return t.item1
            }) : []
        const tasksMenu = this.state.possibleTasks!.map((t: any, i: number) => {
            return <Option key={t.item1} value={t.item1} >{t.item2}</Option>
        })
        return <Form
            layout="inline"
            id="modaForm">
            <FormItem style={{ minWidth: 300, maxWidth: 300 }}>
                <div>
                    {this.props.getFieldDecorator(nameof<LogsRequest>('types'), {
                        initialValue: defaultTypes,
                        rules: [{ required: true, message: t('At least one log type must be specified') },
                        { validator: this.validatProjectSelection }]
                    })(
                        <Select
                            allowClear
                            mode="multiple"
                            className={"custom-select-multiple"}
                            style={{ minWidth: 300, maxWidth: 300 }}
                            placeholder={t('Log types')}
                            filterOption={(input, option) => {
                                if (option.props.children)
                                    return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                return false;
                            }}>
                            <Option key={eventType.TimesheetEntryUpdated} value={eventType.TimesheetEntryUpdated}>{t("Timesheet Entry Updated")}</Option>
                            <Option key={eventType.TimesheetPublished} value={eventType.TimesheetPublished}>{t("Timesheet Published")}</Option>
                            <Option key={eventType.TimesheetAcceptedOrRejected} value={eventType.TimesheetAcceptedOrRejected}>{t("Timesheet Accepted/Rejected")}</Option>
                            <Option key={eventType.ProjectOrTaskCreatedOrModified} value={eventType.ProjectOrTaskCreatedOrModified}>{t("Project or Task Created/Modified")}</Option>
                        </Select>
                    )}
                </div>
            </FormItem>
                <FormItem style={{ display: 'inline-block', marginTop: -1 }} >

                    {this.props.getFieldDecorator(nameof<LogsRequest>('from'), {
                        rules: [{ required: true, message: t('Initial date must be specified') }],
                        initialValue: defaultFromDate
                    })(
                        <DatePicker
                            format='DD-MM-YYYY'
                            disabledDate={this.disabledStartDate}
                        />
                    )}
                </FormItem>
                <FormItem style={{ display: 'inline-block', marginTop: -1, marginLeft: 10 }}  >
                    {this.props.getFieldDecorator(nameof<LogsRequest>('to'), {
                        rules: [{ required: true, message: t('Final date must be specified') }],
                        initialValue: defaultToDate
                    })(
                        <DatePicker
                            format='DD-MM-YYYY'
                            disabledDate={this.disabledEndDate}
                        />
                    )}
                </FormItem>
                <FormItem style={{ minWidth: 300, maxWidth: 300 }}>
                {this.props.getFieldDecorator(nameof<LogsRequest>('employees'), {
                    initialValue: this.props.employees.map((e: EmployeeSummary) => e.identityName),
                    rules: [{ required: true, message: t('At least one employee must be selected') },
                            { validator: this.validatProjectSelection }]
                        })(
                            <Select
                                allowClear
                                mode="multiple"
                                className={"custom-select-multiple"}
                                style={{ minWidth: 300, maxWidth: 300, whiteSpace: "nowrap", maxHeight: '200px', overflow: 'auto'  }}
                                placeholder={t('Employees')}
                                filterOption={(input, option) => {
                                    if (option.props.children)
                                        return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                    return false;
                                }}>
                                {this.props.employees.map((e: EmployeeSummary) => <Option key={e.identityName} value={e.identityName}>{e.title}</Option>)}
                               
                            </Select>
                        )}
                </FormItem>
                <FormItem style={{ minWidth: 300, maxWidth: 300 }}>
                {this.props.getFieldDecorator(nameof<LogsRequest>('projects'), {
                    initialValue: this.props.projects ? this.props.projects.map((p: ProjectSummary) => p.id):[],
                        
                        })(
                            <Select
                                onChange={this.onProjectsChange}
                                allowClear
                                mode="multiple"
                                className={"custom-select-multiple"}
                                style={{ minWidth: 300, maxWidth: 300, whiteSpace: "nowrap", maxHeight: '200px', overflow: 'auto' }}
                                placeholder={t('Projects')}
                                filterOption={(input, option) => {
                                    if (option.props.children)
                                        return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                    return false;
                                }}>
                                {this.props.projects.map((p: ProjectSummary) => <Option value={p.id}>{p.title}</Option>)}
                            </Select>
                        )}
                </FormItem>
            <FormItem style={{ minWidth: 300, maxWidth: 300 }}>
                {this.props.getFieldDecorator(nameof<LogsRequest>('tasks'), {
                    initialValue: defaultTasks,                           
                        })(
                            <Select
                                allowClear
                                mode="multiple"
                                style={{ minWidth: 300, maxWidth: 300, whiteSpace: "nowrap", maxHeight:'200px',  overflow: 'auto' }}
                                placeholder={t('Tasks')}
                                filterOption={(input, option) => {
                                    if (option.props.children)
                                        return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                    return false;
                                }}>
                                {tasksMenu}
                    </Select>
                    )}
                    </FormItem>
                <FormItem >
                    <div style={{ marginLeft: 10, marginTop: -2 }} >
                        <Button
                            onClick={() => { if (this.props.onSave) { this.props.onSave(); } }}
                            style={{ height: 36, width: 36, paddingRight: 11, paddingLeft: 10 }}>
                            <Icon type='reload' />
                        </Button>
                    </div>
                </FormItem>
        </Form>
    }
}

// tslint:disable-next-line:no-empty-interface
interface LogsViewProps extends RouteComponentProps<{ companyId: string }>, WithTranslation, UserProfileProps {
    companyName: string
    refresh: boolean,
    onRefresh: () => void;
}

interface LogsViewState {
    query: Query;
    logsRequestItem: LogsRequest;
    logs: ExpandedLogItem[];
    isBusy?: boolean;
    data: any;
    allData: any;
    employess: EmployeeSummary[];
    projects: ProjectSummary[];
    tasks: any[];
    indexProjects: { [id: string]: ProjectSummary };
    indexTasks: { [id: string]: string };
    selectedStartDate: number;
    selectedEndDate: number;
}

@connect(['projects', ProjectsStore], ['logs', LogsStore], ['employees', EmployeesStore])
class LogsDashboard extends React.Component<LogsViewProps & FormComponentProps, LogsViewState> {
    private get projectsStore() {
        return (this.props as any).projects as ProjectsStore;
    }

    private get logsStore() {
        return (this.props as any).logs as LogsStore;
    }

    private get employeesStore() {
        return (this.props as any).employees as EmployeesStore;
    }
    constructor(props: LogsViewProps & FormComponentProps) {
        super(props);
        var query = { searchQuery: '', orderBy: [{ field: 'timestamp', direction: 'Descending', useProfile: true }], skip: 0, take: 10 }

        this.state = {
            query: query as any,
            logsRequestItem: {} as any as LogsRequest,
            logs: [],
            data: [],
            allData: [],
            employess:[],
            projects: [],
            tasks: [],
            indexTasks: {},
            indexProjects: {},
            selectedStartDate: 0,
            selectedEndDate: 0,
        };
        this.projectsStore.changeUrl(props.match.params.companyId)
        this.logsStore.changeUrl(props.match.params.companyId)
        this.employeesStore.changeUrl(props.match.params.companyId)
    }

    async componentDidMount() {
        let query = this.state.query
        let fromDateStamp = defaultFromDate.startOf('day').unix();
        let toDateStamp = defaultToDate.endOf('day').unix();

        var emplQuery = {
            searchQuery: '',
            orderBy: [{ field: 'title', direction: 'Descending', useProfile: true }],
            skip: 0,
            take: 1000
        }
        let employees = await this.employeesStore.getAllAsync(emplQuery as any)
        var employeesItems = employees.items

        var projectsQuery= {
            searchQuery: '',
            orderBy: [{ field: 'title', direction: 'Descending', useProfile: false }],
            skip: 0,
            take: 1000
        }
        var projects = await this.projectsStore.getAllAsync(projectsQuery as any, undefined, this.props.match.params.companyId)
        var projectsItems = projects.items.filter(p => p.members.any(m => employeesItems.any(e => e.id.toString() == m)))
        var indexProjects: { [id: string]: ProjectSummary } = {}
        projectsItems.forEach((value, index) => { indexProjects[value.id.toString()] = value })
        var indexTasks: { [id: string]: string } = {}
        var tasks = [].concat.apply([], projectsItems.map((value: any, index: any) => {
            var options = value.tasks.map((t: any, i: number) => {
                indexTasks[t.item1] = t.item2
                return t
            })
            return options
        }))
        this.setState({ allData: [...this.logsStore.state.items], projects: projectsItems, tasks: tasks, employess: employeesItems, indexProjects: indexProjects, indexTasks: indexTasks }, () => {
        })
        query = {
            ...query,
            parameters: {
                'fromDateStamp': fromDateStamp,
                'toDateStamp': toDateStamp,
                'employeesIds': this.state.employess.map(e => e.identityName),
                'projects': this.state.projects.map(p => p.title),
                'tasks': this.state.tasks.map(t => t.item2),
                'types': defaultTypes,
            }
        }
        this.onQueryChanged(query);
    }

    @autobind
    private isReadOnly() {
        return (this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("CompanyDataViewer")
                && !(this.props.userProfile.roles.includes("Manager")
                    || this.props.userProfile.roles.includes("Administrator")
                    || this.props.userProfile.roles.includes("ClientAdmin")
                    || this.props.userProfile.roles.includes("FIConsultant"))));
    }

    componentDidUpdate() {
        if (this.props.refresh) {
            this.props.onRefresh()
            this.load(this.state.query)
        }
    }

    @autobind
    private async load(query: Query, update: boolean = true) {
        await this.logsStore.getAllAsync(query, undefined)
        if (update) {
            this.setState({ data: JSON.parse(JSON.stringify(this.logsStore.state)) })
        }

    }

    @autobind
    private onSubmitLogsRequest() {
        var self = this;
        var query = this.state.query
        return new Promise((resolve, reject) => {
            self.props.form.validateFields(event => {
                var values = self.props.form.getFieldsValue();
                if (!event) {
                    let fromDateStamp = (values.from as Moment).startOf("day").unix();
                    let toDateStamp = (values.to as Moment).endOf("day").unix();
                    var employees = values.employees
                    var projects = values.projects.map((p: any) => this.state.indexProjects[p].title)
                    var tasks = values.tasks.map((t: any) => this.state.indexTasks[t])
                    var types = values.types
                    query = {
                        ...query,
                        parameters: {
                            'fromDateStamp': fromDateStamp,
                            'toDateStamp': toDateStamp,
                            'employeesIds': employees,
                            'projects': projects,
                            'tasks': tasks,
                            'types': types,
                        }
                    }
                    this.setState({ selectedStartDate: fromDateStamp, selectedEndDate: toDateStamp })
                    this.onQueryChanged(query)
                }
            });
        })
    }
    @autobind
    private async onDownloadReport() {
        const { t } = this.props as any;
        var self = this;
        var query = this.state.query
        query = {
            ...query
        }
        query.take = 10000
        query.skip = 0

        var result = await this.logsStore.getReportsAsync(query, { responseType: 'arraybuffer', export: true });
        successNotification(this.props.t('Operation Completed Successfully'), this.props.t('Your operation will be processed in background.'));
    }

    @autobind
    private onQueryChanged(query: Query) {
        this.setState({ query }, () => this.load(query));
    }

    public render() {
        const { t } = this.props as any;
        const { getFieldDecorator, getFieldValue, validateFields, setFieldsValue } = this.props.form;
        const tableModel = {
            query: this.state.query,
            columns: [
                {
                    sortable: true,
                    field: 'timestamp',
                    title: t('Date') + " (UTC)",
                    renderer: (data) => <span title={moment(unixEpochToDate(data.dateTimeStamp)).utc().format("DD-MM-YYYY")}>
                        {moment(unixEpochToDate(data.dateTimeStamp)).utc().format("DD-MM-YYYY")}
                    </span>,
                    editor: (data) => <Input />
                }, {
                    field: 'dateTime',
                    title: t('Hour') + " (UTC)",
                    renderer: (data) => <span title={moment(unixEpochToDate(data.dateTimeStamp)).utc().format("hh:mm A")}>
                        {moment(unixEpochToDate(data.dateTimeStamp)).utc().format("hh:mm A")}
                    </span>,
                    editor: (data) => <Input />
                }, {
                    field: 'day',
                    title: t("Timesheet day"),
                    renderer: (data) => <span title={data.type == "Timesheet Entry Updated" ? data.timesheetDay! : "-"}>
                        {data.type == "Timesheet Entry Updated" ? data.timesheetDay! : "-"}
                    </span>,
                    editor: (data) => <Input />
                }, {
                    field: 'type',
                    title: t('Event Type'),
                    renderer: (data) => <span title={t(data.type)} style={{ minWidth: 100 }}>
                        {t(data.type)}
                    </span>,
                    editor: (data) => <Input />
                }, {
                    field: 'userDisplayName',
                    title: t('Username'),
                    renderer: (data) => <span title={data.userDisplayName ?? "-"}>
                        {data.userDisplayName ?? "-"}
                    </span>,
                    editor: (data) => <Input />
                },{
                    field: 'managerDisplayName',
                    title: t('Manager'),
                    renderer: (data) => <span title={data.managerDisplayName ?? "-"}>
                        {data.managerDisplayName ?? "-"}
                    </span>,
                    editor: (data) => <Input />
                },{
                    field: 'projectTitle',
                    title: t('Project Title'),
                    renderer: (data) => <span title={data.projectTitle ?? "-"}>
                        {data.projectTitle ?? "-"}
                    </span>,
                    editor: (data) => <Input />
                },{
                    field: 'taskTitle',
                    title: t('Task Title'),
                    renderer: (data) => <span title={data.taskTitle ?? "-"}>
                        {data.taskTitle ?? "-"}
                    </span>,
                    editor: (data) => <Input />
                },{
                    field: 'timesheetValue',
                    title: t('Timesheet Value'),
                    renderer: (data) => <span title={data.timesheetValue ?? "-"}>
                        {data.timesheetValue ?? "-"}
                    </span>,
                    editor: (data) => <Input />
                },{
                    field: 'comment',
                    title: t('Timesheet Comment'),
                    renderer: (data) => <span title={data.comment ?? "-"}>
                        {data.comment ?? "-"}
                    </span>,
                    editor: (data) => <Input />
                },{
                    field: 'actionComment',
                    title: t('Approval/Reject comment'),
                    renderer: (data) => <span title={data.actionComment ?? "-"}>
                        {data.actionComment??"-"}
                    </span>,
                    editor: (data) => <Input />
                },],
            data: this.state.data,
            sortFields: [{
                field: 'timestamp',
                text: t('Timestamp'),
                useProfile: true
            }],
        } as TableModel<ExpandedLogItem>;
        return <Spin size='large' spinning={this.logsStore.state.isBusy}>
            <div>
                <LogsRequestFormBody
                    item={this.state.logsRequestItem}
                    i18n={this.props.i18n}
                    t={this.props.t}
                    tReady={this.props.tReady}
                    getFieldDecorator={getFieldDecorator}
                    getFieldValue={getFieldValue}
                    setFieldsValue={setFieldsValue}
                    validateFields={validateFields}
                    onSave={this.onSubmitLogsRequest}
                    data={this.state.allData}
                    employees={this.state.employess}
                    projects={this.state.projects}
                    tasks={this.state.tasks}
                    indexProjects={this.state.indexProjects}
                />
            </div>
            <div data-tut="reactour__navegateProject" style={{ padding: 0, margin: 0 }}>
                <TableView
                    rightToolbar={
                        <ul>
                            <li>
                                <Button disabled={!this.state.data} onClick={this.onDownloadReport} > <Icon type="download" /> {t('Download')}  </Button>
                            </li>
                        </ul>}
                    hideRefresh
                    hideFilter
                    showDeleteStatusWindow
                    rowKey='id'
                    model={tableModel}
                    error={this.projectsStore.state.result && !this.projectsStore.state.result.isSuccess && formatMessage(this.projectsStore.state.result)}
                    embedded={false}
                    onQueryChanged={(q: Query) => this.onQueryChanged(q)}
                    onRefresh={() => this.load(this.state.query)}
                    canEdit={false}
                    canDelete={false}
                    canCreateNew={false}
                    showDetailedDeleteReport
                    scroll={{ x: 1500 }}>
                </TableView>
            </div>
        </Spin>
    }
}

// Wire up the React component to the Redux store
export default withUserProfile(withTranslation()(withIdentity(withRouter((Form.create({}) (LogsDashboard as any) as any)))));
